/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Menu/view.blocks to change it.
import React from 'react'
import TwoFactorAuthAction from './TwoFactorAuthAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Menu({
  children,
  viewPath = "/App/Account/Content/Profile/Menu"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Menu.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TwoFactorAuthAction
  viewPath={`${viewPath}/TwoFactorAuthAction`}
/>
</div>
{children}
</React.Fragment>)
}